import { axiosClient } from '@/shared/apis/config';
import { ApiResponse, ErrorResponse } from '@/shared/types';
import { z } from 'zod';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

/**
 * 기존 프로젝트에 컨텐츠(에셋) 추가 API
 * remotion-editor 에셋 피커에서 사용
 */

export const PostProjectContentsRequestSchema = z.object({
  projectId: z.number(),
  contentIds: z.array(z.number()),
});

export type PostProjectContentsRequest = z.infer<
  typeof PostProjectContentsRequestSchema
>;

type PostProjectContentsResponse = ApiResponse<null>;

export const postProjectContentsApi = async (
  params: PostProjectContentsRequest,
) => {
  const { projectId, contentIds } = params;

  const response = await axiosClient.post<PostProjectContentsResponse>(
    `/v1.0/project/${projectId}/contents`,
    { contentIds },
  );

  return response.data;
};

export const usePostProjectContentsApi = () => {
  return useMutation<
    PostProjectContentsResponse,
    AxiosError<ErrorResponse>,
    PostProjectContentsRequest
  >({
    mutationFn: postProjectContentsApi,
  });
};
